import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { GoogleReconnectButton } from "./GoogleReconnectButton";
import { Provider, ProviderStatusResponse } from "../../../types/provider";
import { useDeleteProvider } from "../../../queries/provider";

interface ServiceAccountsTableActionsProps {
  provider: Provider & ProviderStatusResponse;
  refetchStatuses: () => void;
}

export const ServiceAccountsTableActions = ({
  provider,
  refetchStatuses,
}: ServiceAccountsTableActionsProps) => {
  const { t } = useTranslation();
  const { mutate: deleteProvider } = useDeleteProvider();

  return (
    <>
      <Button
        danger
        type="link"
        onClick={(event) => {
          event.stopPropagation();
          deleteProvider(provider.id);
        }}
      >
        {t("remove")}
      </Button>
      {provider.providerName === "google" ? (
        <GoogleReconnectButton
          provider={provider}
          refetchStatuses={refetchStatuses}
        />
      ) : (
        // If the provider is not implemented, show a disabled button, this should theoretically not be possible
        <Button disabled type="link">
          {t(
            "pages.service-accounts.service-accounts-table.provider-not-implemented",
          )}
        </Button>
      )}
    </>
  );
};
